import Category from '../Category/Category.vue';

import {createNamespacedHelpers} from 'vuex';
const {mapGetters} = createNamespacedHelpers('audienceManager/builder');

export default {
    name: 'audience-tab',
    computed: {
        categories() {
            return Object.values(this.categoriesValue(this.tabId));
        },
        ...mapGetters(['categoriesValue'])
    },
    components: {
        Category
    },
    props: {
        tabId: {
            type: String,
            required: true
        }
    }
};